<app-ehe-header [auth]="true" [wellness]="true"></app-ehe-header>

<section class="other-documents-wrapper general-wrapper enable-wellness">
	<div class="container">
		<div class="row">
			<!-- Left hand nav -->
			<div class="col-md-3 g-left hide-on-small">
				<ul class="global-sidebar-nav">
					<li
						[routerLink]="['/wellness/health/record']"
						appEheAnalytics
						[data]="{
							pageUrl: '/wellness/health/record',
							redirectedTo: '/wellness/health/record',
							componentName: 'other documents',
							id: 'Other documents Ehe Reports',
							placement: 'other documents'
						}">
						EHE Reports
					</li>
					<li class="active">Additional Health Documents</li>
				</ul>
			</div>

			<!-- To-do: Refactor so ResponsiveMenu component is not dependent on static index value -->
			<app-responsive-menu [top]="70" [menuItems]="sidebarMenu" class="w-100 hide-on-large"></app-responsive-menu>

			<div class="col-md-9 g-right">
				<div class="left-outline">
					<mat-accordion>
						<mat-expansion-panel expanded>
							<h2 class="o-d-title hide-on-small">Additional Health Documents ({{ numberUploaded }})</h2>
							<div class="document-list">
								<div *ngFor="let item of documents">
									<app-upload-viewer [document]="item"></app-upload-viewer>
								</div>
								<div class="row">
									<span (click)="openUploadDocumentModal()" class="l-button l-button-blue add-document-link">
										<i class="fas fa-plus"></i>Add Documents</span
									>
								</div>
							</div>
							<div class="text-center" *ngIf="noData">{{ noDataMsg }}</div>
							<p>
								Available space: {{ remainingBytes | prettyBytes }}. You used {{ totalBytes | prettyBytes }} of
								{{ storageLimit | prettyBytes }}
							</p>
							<mat-progress-bar mode="determinate" value="{{ totalBytes / (storageLimit / 100) }}"></mat-progress-bar>
						</mat-expansion-panel>
					</mat-accordion>
				</div>
			</div>
		</div>
	</div>
</section>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
